import React, { useContext, useState, useEffect } from "react";
import "./my-patients.scss";

import PageHeader from "../../common/PageHeader/index";
import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import DoctorMyPatientLayout from "./DoctorMyPatientLayout";
import Loader from "../../UI Component/Loader/Loader";
import { useHistory } from "react-router";

import Avatar from "@mui/material/Avatar";
import useWindowSize from "../../../Hooks/useWindowSize";
import { doctorProfileFiles } from "../../../Util/API Calls/APIList";
import SelectDoctorDesktopView from "../../Staff/CommonComponents/SelectDoctorModal/SelectDoctorDesktopView";
import SelectDoctorMobileView from "../../Staff/CommonComponents/SelectDoctorModal/SelectDoctorMobileView";
import StaffHeader from "../../Staff/CommonComponents/StaffHeader";
import DoctorContext from "../../ClinicComponents/ClinicWrapper/DoctorContext";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";

export default function DoctorMyPatients(props) {
  const [activeIndex, setActiveIndex] = useState(1);
  const [patients, setPatients] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  // Loader
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const staff_context = useContext(DoctorContext);
  const [ddlist, setDDlist] = useState([]);
  const maxAvatars = 2;
  const [doctorselectModal, setDoctorSelectModal] = useState(false);
  const [showMobileView, setShowMobileView] = useState(false);
  const size = useWindowSize();
  const [doctor_selected, setDoctorSelected] = useState([]);
  const [temp_doctor_selected, setTempDoctorSelected] = useState([]);
  const [doctorFilterList, setDoctorFilterList] = useState([
    { name: "All", value: "all", doctor_id: doctor_selected },
  ]);
  const [selectedDoctorFilterDrop, setSelectedDoctorFilterDrop] = useState({
    name: "All",
    value: "all",
  });
  const [selectedDoctorFilter, setSelectedDoctorFilter] = useState();
  const [
    showFilterDoctorMyPatientComponent,
    setShowFilterDoctorMyPatientComponent,
  ] = useState(false);
  const [selectedFilterStatus, setSelectedFilterStatus] = useState({
    appointmentStatus: "all",
    doctorNameStatus: "all",
  });
  const [resetFilterData, setResetFilterData] = useState({
    appointmentStatus: "all",
    doctorNameStatus: "all",
  });
  const urlParams = new URLSearchParams(window?.location?.search);
  const pageNumber = urlParams?.get("pageNo");
  let is_staff = localStorage.getItem("user_type");
  let userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  let staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  let term = {
    doctor_ids: temp_doctor_selected,
    sort_by_latest: true,
    show_upcoming: false,
    // consultation_filter: "all",
    page_no: pageNumber ? +pageNumber : 1,
    search_string: "",
    rows_per_page: 10,
  };

  useEffect(() => {
    if (localStorage.getItem("user_type") === "doctor") {
      fetchPatientAppointments(term);
    }
  }, []);

  useEffect(() => {
    let list = [{ name: "All", value: "all" }, ...staff_context.selectedDoctor];
    setDoctorFilterList(list);
    let arr = [];
    staff_context.selectedDoctor.map((data) => arr.push(data.doctor_id));
    setDoctorSelected(arr);
    setTempDoctorSelected(arr);
  }, [staff_context.selectedDoctor]);

  useEffect(() => {
    // fetchUpcomingAppointments();
    if (doctor_selected.length > 0) {
      term["doctor_id"] = doctor_selected;
      fetchPatientAppointments(term);
      // resetFilter();
    }
  }, [doctor_selected]);

  useEffect(() => {
    setDDlist(staff_context.selectedDoctor);
  }, [staff_context.selectedDoctor]);

  const handleModal = () => {
    if (size && size.width < 786) {
      setShowMobileView(true);
    } else {
      setDoctorSelectModal(true);
    }
  };

  function renderRemaining() {
    const remaining = ddlist.length - maxAvatars;
    let dd = "+" + remaining.toString();
    if (remaining < 1) return null;
    return (
      <Avatar
        sx={{
          bgcolor: "#17BAE0",
          border: "2px solid white",
          boxSizing: "content-box",
          cursor: "pointer",
        }}
        style={{ position: "relative", left: `${-16 * maxAvatars + 1}px` }}
        src="/static/images/avatar/1.jpg"
        alt={dd}
        // onClick={() => setDoctorSelectModal(true)}
        onClick={handleModal}
      >
        <p style={{ fontSize: "16px", margin: "0px", color: "white" }}>{dd}</p>
      </Avatar>
    );
  }

  const groupAvatar = () => {
    return (
      <>
        {ddlist.slice(0, maxAvatars).map((ed, i) => (
          <Avatar
            alt={ed.initials}
            sx={{
              bgcolor: `${ed.profile_picture_url ? "white" : "#17BAE0"}`,
              border: "2px solid white",
              boxSizing: "content-box",
              cursor: "pointer",
            }}
            src={doctorProfileFiles + ed.profile_picture_url}
            style={{ position: "relative", left: `${-16 * i}px` }}
            // onClick={() => setDoctorSelectModal(true)}
            onClick={handleModal}
          />
        ))}
        {renderRemaining()}
      </>
    );
  };

  // filter things

  function getAllDoctorsRelatedData(data) {
    localStorage.setItem("patientDoctorName", JSON.stringify(data));
    setSelectedDoctorFilter(data);
    setSelectedDoctorFilterDrop(data);
    if (data.doctor_id !== undefined) {
      setTempDoctorSelected(data.doctor_id);
    } else if (data.value === "all") {
      setTempDoctorSelected(doctor_selected);
    }
    term["doctor_id"] =
      data.doctor_id !== undefined ? [data.doctor_id] : doctor_selected;
    term["page_no"] = 1;
    setActiveIndex(1);
    fetchPatientAppointments(term);
  }

  const fetchPatientAppointmentsByModification = (term) => {
    fetchPatientAppointments(term);
  };

  const fetchDoctorModificationData = (term) => {
    setSelectedDoctorFilter(term);
    setSelectedDoctorFilterDrop(term);
  };

  const handleDoctorList = () => {
    setSelectedDoctorFilter("");
    setSelectedDoctorFilterDrop({ name: "All", value: "all" });
    let term = {
      doctor_id: doctor_selected,
      page_no: 1,
      rows_per_page: 10,
      search_string: "",
      show_upcoming: false,
      sort_by_latest: true,
    };
    localStorage.removeItem("patientDoctorName");
    fetchPatientAppointments(term);
    setTempDoctorSelected(doctor_selected);
    // setDoctorFilterList({
    //   name: "All",
    //   value: "all",
    //   doctor_id: doctor_selected,
    // });
    // setNewArrayDoctorId(arrayAllDoctorId)
  };

  const resetFilter = (event) => {
    setSelectedDoctorFilter("");
    setSelectedDoctorFilterDrop({ name: "All", value: "all" });
    let term = {
      doctor_id: doctor_selected,
      page_no: 1,
      rows_per_page: 10,
      search_string: "",
      show_upcoming: false,
      sort_by_latest: true,
    };
    localStorage.removeItem("patientDoctorName");
    fetchPatientAppointments(term);
    // setDoctorFilterList({
    //   name: "All",
    //   value: "all",
    //   doctor_id: doctor_selected,
    // });
    // setNewArrayDoctorId(arrayAllDoctorId)
    setShowFilterDoctorMyPatientComponent(false);
    setActiveIndex(1);
  };

  const onFilterSuccess = (data) => {
    let term = {
      doctor_id:
        data.doctorNameStatus.doctor_id !== undefined
          ? Array.isArray(data.doctorNameStatus.doctor_id)
            ? data.doctorNameStatus.doctor_id
            : [data.doctorNameStatus.doctor_id]
          : doctor_selected,
      page_no: 1,
      rows_per_page: 10,
      search_string: "",
      show_upcoming: data.appointmentStatus.value === "upcoming" ? true : false,
      sort_by_latest: true,
    };
    fetchPatientAppointments(term);
    setShowFilterDoctorMyPatientComponent(false);
    setSelectedFilterStatus({
      appointmentStatus: data.appointmentStatus.value,
      doctorNameStatus: data.doctorNameStatus.value,
    });
  };

  const onResetFilter = (data) => {
    let term = {
      doctor_id: doctor_selected,
      page_no: 1,
      rows_per_page: 10,
      search_string: "",
      show_upcoming: false,
      sort_by_latest: true,
    };
    fetchPatientAppointments(term);
    setShowFilterDoctorMyPatientComponent(false);
    setSelectedFilterStatus({
      appointmentStatus: "all",
      doctorNameStatus: "all",
    });
  };

  //   API Call =>
  const fetchPatientAppointments = async (term) => {
    let newPayload;
    if (is_staff === "staff") {
      newPayload = term;
      newPayload["doctor_ids"] = Array.isArray(term.doctor_id)
        ? term.doctor_id
        : [term.doctor_id];
    }
    let payload;
    is_staff === "staff"
      ? (payload = {
          ...newPayload,
          staff_id: staffId,
        })
      : (payload = {
          doctor_id: userId,
          page_no: term.page_no,
          rows_per_page: term.rows_per_page,
          search_string: term.search_string,
          show_upcoming: term.show_upcoming,
          sort_by_latest: term.sort_by_latest,
        });

    setLoading(true);
    if (
      (payload?.doctor_ids?.length > 0 &&
        payload?.doctor_ids[0] !== "undefined") ||
      payload?.doctor_id
    ) {
      const response = await afterLoginApiAxios.post(
        `${
          is_staff === "staff"
            ? "/staff/view-patient-appointments-rev1"
            : "/doctor/view-patient-appointments-rev2"
        }`,
        {
          ...payload,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      );
      if (response) {
        if (response.data.statusCode === 200) {
          setPatients(response.data.result);
          setPageCount(response.data.total_page_count);
          setCurrentPage(response.data.current_page_no);
          setActiveIndex(response.data.current_page_no);
          history.replace(
            `/doctor/account/mypatients?pageNo=${
              response?.data?.current_page_no
                ? response?.data?.current_page_no
                : 1
            }`
          );
          setTotalCount(response.data.total_rows);
          setLoading(false);
        } else {
          // setLoading(false);
        }
      } else {
        // setLoading(false);
      }
    }
  };
  // <=

  function openFilterDoctorMyPatientComponent() {
    setShowFilterDoctorMyPatientComponent(true);
  }

  function handleShowFilterDoctorMyPatientComponent() {
    setShowFilterDoctorMyPatientComponent(false);
  }

  return (
    <div className="my-patients">
      {loading ? <Loader /> : null}
      {/* Page Header */}
      {is_staff === "staff" ? (
        <div className="b-bottom">
          <StaffHeader isPageHeading={true} headerText={"My Patients"} />
        </div>
      ) : (
        // <div className="row m-0 p-3 staff_page_heading_web" style={{display: "flex", alignItems: "center", borderBottom: "1px solid #D6DAE5"}}>
        //   <div className="staff_page_heading_name" style={{flex: "1"}}>
        //     <PageHeader heading="My Patients" subheading="" />
        //   </div>
        //   <div style={{display: "flex"}}>
        //     {groupAvatar()}
        //     <AvatarGroup>
        //       <Avatar
        //         className="ml-2"
        //         src={ddlist.length > 1 ? AvatarIcon : AvatarBlue}
        //         sx={{
        //           bgcolor: "white",
        //           boxSizing: "content-box",
        //           cursor: "pointer",
        //         }}
        //         // onClick={() => setDoctorSelectModal(true)}
        //         onClick={handleModal}
        //       />
        //     </AvatarGroup>
        //   </div>
        // </div>
        <div className="row m-0 pt-4 page_heading_web">
          <div className="col-12">
            <PageHeader heading="My Patients" subheading="" />
          </div>
        </div>
      )}
      <DoctorMyPatientLayout
        onSubmit={fetchPatientAppointmentsByModification}
        doctorsRelatedDataStatus={fetchDoctorModificationData}
        pageCount={pageCount}
        currentPage={currentPage}
        totalCount={totalCount}
        patients={patients}
        refreshData={fetchPatientAppointments}
        handleDoctorList={handleDoctorList}
        resetFilter={resetFilter}
        getAllDoctorsRelatedData={getAllDoctorsRelatedData}
        doctorFilterList={doctorFilterList}
        selectedDoctorFilter={selectedDoctorFilter}
        selectedDoctorFilterDrop={selectedDoctorFilterDrop}
        doctor_selected={doctor_selected}
        temp_doctor_selected={temp_doctor_selected}
        onFilterSuccess={onFilterSuccess}
        onResetFilter={onResetFilter}
        showFilterDoctorMyPatientComponent={showFilterDoctorMyPatientComponent}
        openFilterDoctorMyPatientComponent={openFilterDoctorMyPatientComponent}
        handleShowFilterDoctorMyPatientComponent={
          handleShowFilterDoctorMyPatientComponent
        }
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        selectedFilterStatus={selectedFilterStatus}
        setSelectedFilterStatus={setSelectedFilterStatus}
        resetFilterData={resetFilterData}
        setResetFilterData={setResetFilterData}
      />
      {doctorselectModal ? (
        <SelectDoctorDesktopView
          show={doctorselectModal}
          onHide={() => {
            setDoctorSelectModal(false);
          }}
        />
      ) : null}

      {showMobileView ? (
        <SelectDoctorMobileView
          show={showMobileView}
          onHide={() => setShowMobileView(false)}
        />
      ) : null}
    </div>
  );
}
